export class WhatsAppCommunication
{
    toNumber:string;
    toName:string;
    templateId:string;
    messageDetails:string;
    fileName:string;
    file:File
}